import { Component, OnInit } from '@angular/core';
import { LimitePagamentoEcgTerceiro } from 'src/app/model/limite-pagamento-ecg-terceiro';
import { LimitePagamentoEcgTerceiroService } from '../../limite-pagamento-ecg-terceiro.service';
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-limite-pagamento-ecg-por-terceiros-pesquisa',
  templateUrl: './limite-pagamento-ecg-por-terceiros-pesquisa.component.html',
  styleUrls: ['./limite-pagamento-ecg-por-terceiros-pesquisa.component.scss'],
  standalone: false
})
export class LimitePagamentoEcgPorTerceirosPesquisaComponent implements OnInit {

  limites: LimitePagamentoEcgTerceiro[];
  dataHoraResultado: string;

  constructor(
    private limiteService: LimitePagamentoEcgTerceiroService,
    private loadingService: BnLoadingService,
    private abrirModal: NgbModal,
  ) { }

  ngOnInit(): void {
    this.buscarLimites();
  }

  buscarLimites() {
    this.loadingService.bloqueiaTela();
    this.limiteService.buscarLimitesPagamentoEcgTerceiros().subscribe({
      next: (response) => {
        this.limites = response;
        this.dataHoraResultado = moment().format('YYYY-MM-DD HH:mm:ss');
        this.loadingService.liberaTela();
      },
      error: (err) => {
        console.log(err);
        this.loadingService.liberaTela();
      }
    })
  }

}
